import React, { PureComponent } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Container, InnerContainer } from './styles';

import LiveEventsList from './LiveEventsList/component';
import { IProps } from './interfaces';
import { IState } from '../../state/search';
import { Routes as AppRoutes } from '../../constants';

class LiveEvents extends PureComponent<IProps, IState> {
  render() {
    return (
      <Container>
        <InnerContainer>
          <Routes>
            <Route index element={<LiveEventsList />} />
            <Route path="*" element={<Navigate to={AppRoutes.MANAGE_LIVE_EVENTS} replace />} />
          </Routes>
        </InnerContainer>
      </Container>
    );
  }
}

export default LiveEvents;
